import { Pipe, PipeTransform } from '@angular/core';

const unitMap = {
    kB: 1,
    MB: 2
};

@Pipe({
    name: 'byteConvert',
    standalone: true
})
export class ByteConvertPipe implements PipeTransform {
    transform(bytes?: number, unit?: string): string {
        if (isNaN(parseFloat(String(bytes)))) {
            return '?';
        }

        if (!unit || !unitMap[unit]) {
            return '?';
        }

        const divisor = Math.pow(1024, unitMap[unit ?? 'kB']);

        return `${(bytes / divisor).toFixed(2)} ${unit ?? 'kB'}`;
    }
}
